import { ECustomNotificationTarget } from '../types/custom-notification.types';

export const ECustomNotificationTargetMap = {
  [ECustomNotificationTarget.ALL]: {
    title: 'Everyone',
  },
  [ECustomNotificationTarget.COMPANY_ADMINS]: {
    title: 'Company Admins',
  },
};
